import { callClient } from "@q/softCore";
import { IS_CLIENT } from "@/common/api";

/* 呼起页游时客户端需判断安装flash逻辑，由前端检测后通知客户端 */
function noticeInstallFlash() {
  const installed =
    navigator.mimeTypes["application/x-shockwave-flash" as any] !== undefined;

  if (IS_CLIENT) {
    callClient("installedFlash", Number(installed));
  }
}

noticeInstallFlash();
